"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatHeader = require("./ChatHeader");
Object.keys(_ChatHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatHeader[key];
    }
  });
});
var _ChatPreview = require("./ChatPreview");
Object.keys(_ChatPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatPreview[key];
    }
  });
});
var _ChatErrorMessage = require("./ChatErrorMessage");
Object.keys(_ChatErrorMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatErrorMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatErrorMessage[key];
    }
  });
});
var _ChatMessageSimple = require("./ChatMessageSimple");
Object.keys(_ChatMessageSimple).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatMessageSimple[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatMessageSimple[key];
    }
  });
});
var _EmptyStateIndicator = require("./EmptyStateIndicator");
Object.keys(_EmptyStateIndicator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmptyStateIndicator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EmptyStateIndicator[key];
    }
  });
});
var _OneToOneChat = require("./OneToOneChat");
Object.keys(_OneToOneChat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OneToOneChat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OneToOneChat[key];
    }
  });
});
var _ChatIcon = require("./ChatIcon");
Object.keys(_ChatIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatIcon[key];
    }
  });
});
var _Channel = require("./Channel");
Object.keys(_Channel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Channel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Channel[key];
    }
  });
});
var _SendMessageButton = require("./SendMessageButton");
Object.keys(_SendMessageButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SendMessageButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SendMessageButton[key];
    }
  });
});
var _ChatMessageInput = require("./ChatMessageInput");
Object.keys(_ChatMessageInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatMessageInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatMessageInput[key];
    }
  });
});